module.exports = __webpack_public_path__ + "img/ISO.8fec9bcb.png";